import * as Types from '@findy-code/yuffie/graphql';

import { gql } from '@apollo/client';
import { FetchJobDescriptionDetailCompanyInterviewFragmentDoc, FetchJobDescriptionDetailFindyToolsArticleFragmentDoc, TeamPlusAwardFragmentDoc, JobDescriptionCompanyAiUsageFragmentDoc } from './job-description-detail.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchJobDescriptionQueryVariables = Types.Exact<{
  jdHash: Types.Scalars['String']['input'];
}>;


export type FetchJobDescriptionQuery = { __typename?: 'Query', jobDescription: { __typename?: 'JobDescription', id: number, jdHash: string, title: string, jobDescription: string, rewarding?: string | null, personality?: string | null, employmentPatternNote?: string | null, developmentEnvironment?: string | null, mustSkills?: string | null, desiredSkills?: string | null, numericSalaryMin?: number | null, numericSalaryMax?: number | null, basicSalaryType?: Types.JobDescriptionBasicSalary | null, basicSalaryMin?: number | null, basicSalaryMax?: number | null, salary?: string | null, salaryExamples?: string | null, salaryRemark?: string | null, bonus?: string | null, trialPeriod?: string | null, breakTime?: string | null, overtimeWork?: string | null, insurance?: string | null, smokingPolicy?: string | null, location?: string | null, workHours?: string | null, holidays?: string | null, welfare?: string | null, otherBenefits?: string | null, careerUpPrograms?: string | null, health?: string | null, screeningProcess?: string | null, others?: string | null, createdAt: string, publishedAt?: string | null, updatedAt: string, jobDescriptionIntroductionSlide?: { __typename?: 'JobDescriptionIntroductionSlide', url: string } | null, jobDescriptionsCharacteristics: Array<{ __typename?: 'JobDescriptionsCharacteristic', id: number, name: string }>, jobDescriptionEmploymentPattern?: { __typename?: 'JobDescriptionEmploymentPattern', name: string } | null, jobType?: { __typename?: 'JobType', id: number, name: string } | null, managementJobType?: { __typename?: 'ManagementJobType', id: number, name: string } | null, company: { __typename?: 'Company', id: number, name: string, location?: string | null, url: string, imageUrl: string, images: Array<{ __typename?: 'File', filename: string, url: string }>, publishedInterviews: Array<{ __typename?: 'CompanyInterview', id: number, alias: string, title?: string | null, thumbnailUrl?: string | null, publishedAt?: string | null }>, publishedFindyToolsArticles: Array<{ __typename?: 'FindyToolsArticle', id: number, title: string, articleUrl: string, thumbnailUrl: string, publishedAt?: string | null }>, teamPlusAward?: { __typename?: 'CompanyTeamPlusAward', label: string } | null, companyAiUsage?: { __typename?: 'CompanyAiUsage', isUsingAi: boolean, comment?: string | null, latestUpdatedAt: string, companyAiUsageAnswers: Array<{ __typename?: 'CompanyAiUsageAnswer', companyAiUsageAnswerOption: { __typename?: 'CompanyAiUsageAnswerOption', label: string } }>, companyAiUsageSkills: Array<{ __typename?: 'CompanyAiUsageSkill', skill: { __typename?: 'Skill', id: number, name: string } }> } | null }, companiesMembers: Array<{ __typename?: 'CompanyMember', id: number, name: string, githubAccount?: string | null }>, skills: Array<{ __typename?: 'Skill', id: number, name: string }>, tags: Array<{ __typename?: 'PersonalityTag', id: number, name: string }>, match?: { __typename?: 'Match', id: number, matchHash: string } | null, jobDescriptionLike?: { __typename?: 'JobDescriptionLike', id: number, likeHash: string, isKeep: boolean, likeExpirationDate: string, isUserSuccessCommitmentJobInterview: boolean, enterpriseUser?: { __typename?: 'EnterpriseUser', id: number, firstName: string, familyName: string, avatar?: { __typename?: 'File', filename: string, url: string } | null } | null, enterprisePremiumScout?: { __typename?: 'EnterprisePremiumScout', id: number, messages: Array<{ __typename?: 'EnterprisePremiumScoutMessage', id: number, message: string }> } | null } | null, userLike?: { __typename?: 'UserLike', id: number } | null } };

export type FetchJobDescriptionDetailFragment = { __typename?: 'JobDescription', id: number, jdHash: string, title: string, jobDescription: string, rewarding?: string | null, personality?: string | null, employmentPatternNote?: string | null, developmentEnvironment?: string | null, mustSkills?: string | null, desiredSkills?: string | null, numericSalaryMin?: number | null, numericSalaryMax?: number | null, basicSalaryType?: Types.JobDescriptionBasicSalary | null, basicSalaryMin?: number | null, basicSalaryMax?: number | null, salary?: string | null, salaryExamples?: string | null, salaryRemark?: string | null, bonus?: string | null, trialPeriod?: string | null, breakTime?: string | null, overtimeWork?: string | null, insurance?: string | null, smokingPolicy?: string | null, location?: string | null, workHours?: string | null, holidays?: string | null, welfare?: string | null, otherBenefits?: string | null, careerUpPrograms?: string | null, health?: string | null, screeningProcess?: string | null, others?: string | null, createdAt: string, publishedAt?: string | null, updatedAt: string, jobDescriptionIntroductionSlide?: { __typename?: 'JobDescriptionIntroductionSlide', url: string } | null, jobDescriptionsCharacteristics: Array<{ __typename?: 'JobDescriptionsCharacteristic', id: number, name: string }>, jobDescriptionEmploymentPattern?: { __typename?: 'JobDescriptionEmploymentPattern', name: string } | null, jobType?: { __typename?: 'JobType', id: number, name: string } | null, managementJobType?: { __typename?: 'ManagementJobType', id: number, name: string } | null, company: { __typename?: 'Company', id: number, name: string, location?: string | null, url: string, imageUrl: string, images: Array<{ __typename?: 'File', filename: string, url: string }>, publishedInterviews: Array<{ __typename?: 'CompanyInterview', id: number, alias: string, title?: string | null, thumbnailUrl?: string | null, publishedAt?: string | null }>, publishedFindyToolsArticles: Array<{ __typename?: 'FindyToolsArticle', id: number, title: string, articleUrl: string, thumbnailUrl: string, publishedAt?: string | null }>, teamPlusAward?: { __typename?: 'CompanyTeamPlusAward', label: string } | null, companyAiUsage?: { __typename?: 'CompanyAiUsage', isUsingAi: boolean, comment?: string | null, latestUpdatedAt: string, companyAiUsageAnswers: Array<{ __typename?: 'CompanyAiUsageAnswer', companyAiUsageAnswerOption: { __typename?: 'CompanyAiUsageAnswerOption', label: string } }>, companyAiUsageSkills: Array<{ __typename?: 'CompanyAiUsageSkill', skill: { __typename?: 'Skill', id: number, name: string } }> } | null }, companiesMembers: Array<{ __typename?: 'CompanyMember', id: number, name: string, githubAccount?: string | null }>, skills: Array<{ __typename?: 'Skill', id: number, name: string }>, tags: Array<{ __typename?: 'PersonalityTag', id: number, name: string }>, match?: { __typename?: 'Match', id: number, matchHash: string } | null, jobDescriptionLike?: { __typename?: 'JobDescriptionLike', id: number, likeHash: string, isKeep: boolean, likeExpirationDate: string, isUserSuccessCommitmentJobInterview: boolean, enterpriseUser?: { __typename?: 'EnterpriseUser', id: number, firstName: string, familyName: string, avatar?: { __typename?: 'File', filename: string, url: string } | null } | null, enterprisePremiumScout?: { __typename?: 'EnterprisePremiumScout', id: number, messages: Array<{ __typename?: 'EnterprisePremiumScoutMessage', id: number, message: string }> } | null } | null, userLike?: { __typename?: 'UserLike', id: number } | null };

export type FetchJobDescriptionDetailCompanyFragment = { __typename?: 'Company', id: number, name: string, location?: string | null, url: string, imageUrl: string, images: Array<{ __typename?: 'File', filename: string, url: string }>, publishedInterviews: Array<{ __typename?: 'CompanyInterview', id: number, alias: string, title?: string | null, thumbnailUrl?: string | null, publishedAt?: string | null }>, publishedFindyToolsArticles: Array<{ __typename?: 'FindyToolsArticle', id: number, title: string, articleUrl: string, thumbnailUrl: string, publishedAt?: string | null }>, teamPlusAward?: { __typename?: 'CompanyTeamPlusAward', label: string } | null, companyAiUsage?: { __typename?: 'CompanyAiUsage', isUsingAi: boolean, comment?: string | null, latestUpdatedAt: string, companyAiUsageAnswers: Array<{ __typename?: 'CompanyAiUsageAnswer', companyAiUsageAnswerOption: { __typename?: 'CompanyAiUsageAnswerOption', label: string } }>, companyAiUsageSkills: Array<{ __typename?: 'CompanyAiUsageSkill', skill: { __typename?: 'Skill', id: number, name: string } }> } | null };

export const FetchJobDescriptionDetailCompanyFragmentDoc = gql`
    fragment FetchJobDescriptionDetailCompany on Company {
  id
  name
  location
  url
  imageUrl
  images {
    filename
    url
  }
  publishedInterviews {
    ...FetchJobDescriptionDetailCompanyInterview
  }
  publishedFindyToolsArticles {
    ...FetchJobDescriptionDetailFindyToolsArticle
  }
  teamPlusAward {
    ...TeamPlusAward
  }
  companyAiUsage {
    ...JobDescriptionCompanyAiUsage
  }
}
    ${FetchJobDescriptionDetailCompanyInterviewFragmentDoc}
${FetchJobDescriptionDetailFindyToolsArticleFragmentDoc}
${TeamPlusAwardFragmentDoc}
${JobDescriptionCompanyAiUsageFragmentDoc}`;
export const FetchJobDescriptionDetailFragmentDoc = gql`
    fragment FetchJobDescriptionDetail on JobDescription {
  id
  jdHash
  title
  jobDescription
  jobDescriptionIntroductionSlide {
    url
  }
  jobDescriptionsCharacteristics {
    id
    name
  }
  rewarding
  personality
  jobDescriptionEmploymentPattern {
    name
  }
  employmentPatternNote
  developmentEnvironment
  mustSkills
  desiredSkills
  numericSalaryMin
  numericSalaryMax
  basicSalaryType
  basicSalaryMin
  basicSalaryMax
  salary
  salaryExamples
  salaryRemark
  bonus
  trialPeriod
  breakTime
  overtimeWork
  insurance
  smokingPolicy
  location
  workHours
  holidays
  welfare
  otherBenefits
  careerUpPrograms
  health
  screeningProcess
  others
  createdAt
  publishedAt
  jobType {
    id
    name
  }
  managementJobType {
    id
    name
  }
  company {
    ...FetchJobDescriptionDetailCompany
  }
  companiesMembers {
    id
    name
    githubAccount
  }
  skills {
    id
    name
  }
  tags {
    id
    name
  }
  skills {
    id
    name
  }
  match {
    id
    matchHash
  }
  jobDescriptionLike {
    id
    likeHash
    isKeep
    likeExpirationDate
    enterpriseUser {
      id
      firstName
      familyName
      avatar {
        filename
        url
      }
    }
    enterprisePremiumScout {
      id
      messages {
        id
        message
      }
    }
    isUserSuccessCommitmentJobInterview
  }
  updatedAt
  userLike {
    id
  }
}
    ${FetchJobDescriptionDetailCompanyFragmentDoc}`;
export const FetchJobDescriptionDocument = gql`
    query FetchJobDescription($jdHash: String!) {
  jobDescription(jdHash: $jdHash) {
    ...FetchJobDescriptionDetail
  }
}
    ${FetchJobDescriptionDetailFragmentDoc}`;

/**
 * __useFetchJobDescriptionQuery__
 *
 * To run a query within a React component, call `useFetchJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobDescriptionQuery({
 *   variables: {
 *      jdHash: // value for 'jdHash'
 *   },
 * });
 */
export function useFetchJobDescriptionQuery(baseOptions: Apollo.QueryHookOptions<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables> & ({ variables: FetchJobDescriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables>(FetchJobDescriptionDocument, options);
      }
export function useFetchJobDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables>(FetchJobDescriptionDocument, options);
        }
export function useFetchJobDescriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables>(FetchJobDescriptionDocument, options);
        }
export type FetchJobDescriptionQueryHookResult = ReturnType<typeof useFetchJobDescriptionQuery>;
export type FetchJobDescriptionLazyQueryHookResult = ReturnType<typeof useFetchJobDescriptionLazyQuery>;
export type FetchJobDescriptionSuspenseQueryHookResult = ReturnType<typeof useFetchJobDescriptionSuspenseQuery>;
export type FetchJobDescriptionQueryResult = Apollo.QueryResult<FetchJobDescriptionQuery, FetchJobDescriptionQueryVariables>;